import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import InvestmentDriversItem from "./InvestmentDriversItem";
import { useLanguage } from "../../context/LanguageContext";
import { FaShieldAlt, FaDollarSign, FaGlobe, FaUsers } from "react-icons/fa";

const InvestmentDrivers = () => {
  const { t } = useLanguage();

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 4 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const driverItems = [
    {
      icon: <FaShieldAlt />,
      iconColor: "#17a2b8",
      title: t("investmentDrivers.items.0.title"),
      description: t("investmentDrivers.items.0.description"),
    },
    {
      icon: <FaDollarSign />,
      iconColor: "#ffc107",
      title: t("investmentDrivers.items.1.title"),
      description: t("investmentDrivers.items.1.description"),
    },
    {
      icon: <FaGlobe />,
      iconColor: "#17a2b8",
      title: t("investmentDrivers.items.2.title"),
      description: t("investmentDrivers.items.2.description"),
    },
    {
      icon: <FaUsers />,
      iconColor: "#ffc107",
      title: t("investmentDrivers.items.3.title"),
      description: t("investmentDrivers.items.3.description"),
    },
  ];

  const toMultiply = 100 / driverItems.length;

  return (
    <section className="investment-drivers-area py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section-title text-center mb-50">
              <h2 className="title">
                {t("investmentDrivers.title").split("Hajtóerők").map((part, index, array) => (
                  <React.Fragment key={index}>
                    {part}
                    {index < array.length - 1 && <span className="text-info">Hajtóerők</span>}
                  </React.Fragment>
                ))}
              </h2>
              <p className="description text-light mt-4" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                {t("investmentDrivers.description")}
              </p>
            </div>
          </div>
        </div>

        <div className="row investment-drivers-active">
          <SlickSlider settings={slickSettings}>
            {driverItems.map((item, index) => (
              <div key={index} className="col-lg-6 px-3">
                <InvestmentDriversItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div 
          className="slide-progressbar"
          style={{
            display: "block",
            width: "100%",
            height: "3px",
            borderRadius: "0",
            background: "rgba(255, 255, 255, 0.1)",
            marginTop: "30px"
          }}
        >
          <div
            style={{
              height: "2px",
              backgroundImage: "linear-gradient(to right, #00c4f4, #00c4f4)",
              backgroundRepeat: "no-repeat",
              backgroundSize: `${count * toMultiply}% 100%`,
              transition: "background-size 0.3s ease"
            }}
            className="slide-filler"
          />
        </div>
      </div>
    </section>
  );
};

export default InvestmentDrivers;
